import {AssetType} from "../../Utils";
import {AssetMapData} from "../AssetMapData";
import {IAsset} from "./IAsset";

export class TextureAtlasAsset extends AssetMapData implements IAsset<PIXI.loaders.TextureDictionary> {

    constructor(assetName: string, assetPath?: string) {
        super(assetName, AssetType.TEXTURE_ATLAS);
        if (assetPath) {
            this.assetPath = assetPath;
        }
    }

    public getAsset(): PIXI.loaders.TextureDictionary {
        return this.getResource().textures!;
    }
}
